import styled from 'styled-components';

export const Step1Styles = styled.div`
	&& li {
		border-bottom: none;
	}
`;
